import userauth from '~/helpers/userauth'

export default (to, from, next) => {
    if (!userauth.isSuperAdmin()) {
        next({name: 'dashboard'})
    } else {
        next()
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/admin.js